import type { IrbStudy } from "./types";

// Single source of the IRB protocol display names (with protocol numbers) and
// the lab that runs the protocols — mirrors the backend common/labels.py so
// the admin UI has one copy, not one per table/select.
export const IRB_STUDY_LABELS: Record<IrbStudy, string> = {
  mgb_patients: "MGB patients (2025P002466)",
  healthy_volunteers: "Healthy volunteers (2024P002684)",
  neuroage: "NeuroAge (2026P002249)",
};

export const LAB_NAME = "AIM Lab";
